import React from "react"
import Icon from "../components/icon"

export const metadata =
  "pushfusion is a cloud-based, hardware vendor agnostic dashboard that brings information together from devices across your entire estate and presents it to you in one place, creating a new level of safety and confidence in compliance to your building users."

export const segments = [
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="factory"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Industry</h3>,
    description:
      "Keep production lines rolling by taking control of your compliance.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="office-building"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Office</h3>,
    description:
      "Use the data from your buildings to show your commitment to safer working environments.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="warehouse"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Warehouse</h3>,
    description:
      "Make sure your distribution stays on track by unleashing the power of predictive maintenance.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="modern-house"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Social Housing</h3>,
    description:
      "Have confidence in your regulatory compliance at the click of a button.",
  },

  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="retail"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Retail</h3>,
    description:
      "Drive customer engagement and trust through building data you can rely on.",
  },
]

export const mobile = [
  {
    name: "Compliance",
    description:
      "Get a quick overview of your emergency lighting health. Each installation is represented by an icon, so you can quickly see which installations have compliance issues that need attention.",
  },
  {
    name: "Failures",
    description: (
      <>
        The <span className="text-gray-900 font-bold">push</span>
        <span className="text-pushfusion font-extrabold">fusion</span> mobile
        app can access all the historical data stored in the cloud for your
        buildings to give greater context to your field engineers when trying to
        diagnose local faults. Filter the data for the failed tests and events
        since the last successful test to get the information that’s relevant
        right now.
      </>
    ),
  },
  {
    name: "Job List",
    description:
      "Looking for a tool that can help field engineers stay organized whilst onsite? Job lists help them keep track of their workload and gives them the confidence to move on to the next job when they’re finished.",
  },
]

export const dashboard = [
  {
    name: "Secure",
    description: (
      <>
        Secure cloud-based solution hosted by{" "}
        <a
          href="https://binaryforge.io?utm_source=pushfusion&utm_medium=referral&utm_id=link"
          target="_blank"
          rel="noreferrer"
          className="corp"
        >
          Binary Forge
        </a>
        , so you don’t need to worry about server administration or maintenance.{" "}
      </>
    ),
  },
  {
    name: "Intuitive",
    description:
      "Developed for our end users, the interface delivers revolves around reporting by exception to ensure you get to the information you need without delay.",
  },
  {
    name: "Analytics",
    description:
      "Advanced analytics tools allow for automated analysis of the data, driving management information and fuelling greater cost savings through better decision making.",
  },
  {
    name: "White Label",
    description:
      "Fully customisable user interface supporting localisation and client branding.",
  },
]
